import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 完整下一版。payload 必須帶 detail 的 record.updatedAt。 */
export async function replaceInspectionKind(id, payload) {
  const { data: raw } = await request.put(
    `/ims/inspection-kinds/${id}`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
